import CreatorScreen from "./scenes/CreatorScreen";
import LearnScreen from "./scenes/LearnScreen";
import PrintScreen from "./scenes/PrintScreen";

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [LearnScreen, CreatorScreen, PrintScreen],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: LearnScreen.KEY,
    // startScene: CreatorScreen.KEY,
    // startScene: PrintScreen.KEY,

    // allows debugging mobile in dev
    forceMobile: false,
    isMobile: false,
    KEY_UP_COLOR: 0xFFFFFF,
    KEY_DOWN_COLOR: 0xD3D7E0,
    creatorPageIndex: 0,
    letterData: {
        date: "",
        address: "",
        salutation: "",
        body: "",
        closing: "",
        signature: ""
    }
}
